import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import 'components/tenant_app/tenant_showing.css';

import BookingIcon from '@material-ui/icons/DateRangeTwoTone';

import TenantAmenityBookingDialog from './TenantAmenityBookingDialog';
import { AccentColor } from 'helpers/AccentColorHelper';

import { getTenantTodoList } from 'actions/todoActions';

import { localize } from 'react-localize-redux';
import { FlatButton } from 'material-ui';

const StyledTodoContainer = styled.div`
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
`;

const StyledTodoCopyP = styled.p`
  width: calc(100% - 56px);
  margin: 0;
  line-height: 24px;
`;

const AmenityBookingTodo = class AmenityBookingTodo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBooking: false,
      amenityDetails: {},
    };
  }

  toggleBookingDialog = amenityDetails => {
    this.setState(prevState => ({ showBooking: !prevState.showBooking, amenityDetails }));
  };

  onComplete = () => {
    this.props.getTenantTodoList();
    this.toggleBookingDialog();
    window.gtag('event', 'create_amenity_booking', {
      event_category: 'engagement',
      event_label: 'resident_portal',
    });
  };

  render() {
    const data = this.props.showingData;

    const style = {
      due_date: {
        color: '#6F6F6F',
        fontSize: '15px',
        textAlign: 'center',
      },
      second_tier: {
        fontSize: '14px',
        color: '#6F6F6F',
        marginTop: '-15px',
      },
    };

    return (
      <React.Fragment>
        <FlatButton
          onClick={this.toggleBookingDialog}
          style={{
            fontSize: '15px',
            color: '#3e3e3e',
            width: '100%',
            minHeight: '55px',
            height: 'inherit',
            textAlign: 'inherit',
          }}
          tabIndex="1"
        >
          <StyledTodoContainer>
            <BookingIcon style={{ color: AccentColor() }} />
            <StyledTodoCopyP>
              {data.name} {this.props.translate('todo.booking')}
              <br />
              <span style={style.second_tier}>{data.showing_time}</span>
            </StyledTodoCopyP>
          </StyledTodoContainer>
        </FlatButton>
        <TenantAmenityBookingDialog
          amenityDetails={this.props.showingData}
          toggleBookingDialog={this.toggleBookingDialog}
          showBooking={this.state.showBooking}
          onComplete={this.onComplete}
        />
      </React.Fragment>
    );
  }
};

export default localize()(connect(null, { getTenantTodoList })(AmenityBookingTodo));
